import { combine, withAsyncEffect } from 'react-hooks-combine'
import bootstrap from 'bootstrap'

import AppicationComponent from './app.component'

export default combine(
  withAsyncEffect({
    deps: [],
    asyncAction: bootstrap.setup,
  })
)(AppicationComponent)
